import React from "react";
import { FontStyle, Inputs } from "../constants";

const DefaultRenderOption = ({ idx, firstIsPlaceholder, option }) => {
  return (
    <option
      value={firstIsPlaceholder && idx === 0 ? "" : option.value}
      key={idx}
      disabled={(firstIsPlaceholder && idx === 0) || option.disabled}>
      {option.label}
    </option>
  );
};

const FettiSelect = ({
  options,
  firstIsPlaceholder = false,
  renderOption = null,
  ...props
}) => {
  return (
    <select
      style={{
        ...FontStyle.body,
        borderRadius: Inputs.borderRadius,
        border: "1px solid #222",
        // border: "1px solid #000",
        padding: `${Inputs.py} ${Inputs.px}`,
        fontSize: "16px",
        width: "100%",
        color: firstIsPlaceholder && props.value === "" ? "gray" : "black",
        ...(props.disabled && {
          color: "gray",
          backgroundColor: "#eee",
        }),
      }}
      {...props}>
      {/* {options.map((option, index) => (
        <option
          value={firstIsPlaceholder && index === 0 ? "" : option.value}
          key={index}
          disabled={(firstIsPlaceholder && index === 0) || option.disabled}>
          {option.label}
        </option>
      ))} */}
      {options.map((option, index) => {
        if (renderOption) {
          return renderOption({
            idx: index,
            firstIsPlaceholder,
            option,
            key: index,
          });
          // <React.Fragment key={index}>
          //   {renderOption({
          //     idx: index,
          //     firstIsPlaceholder,
          //     option,
          //   })}
          // </React.Fragment>
        } else {
          return (
            <DefaultRenderOption
              key={index}
              idx={index}
              firstIsPlaceholder={firstIsPlaceholder}
              option={option}
            />
          );
        }
      })}
    </select>
  );
};

export default FettiSelect;
